import React, { FunctionComponent } from "react";

// Context
import { useCart } from "../../../context/CartContext";
// Utils
import { displayWeight } from "../../../utils/displayWeight";
// Styles
import "./CheckoutSummary.scss";
import { displayMoney } from "../../../utils/displayMoney";
import classNames from "classnames";

type CheckoutSummaryItemProps = {
  header: React.ReactNode;
  children: React.ReactNode;
};

const CheckoutSummaryItem: FunctionComponent<CheckoutSummaryItemProps> = ({
  header,
  children,
}) => (
  <div className="checkout-summary__item">
    <p className="checkout-summary__item__header">{header}</p>
    <div className="checkout-summary__item__amount">
      <p className="checkout-summary__item__amount__description">{children}</p>
    </div>
  </div>
);

type CheckoutSummarIconProps = {
  modifier: "silver" | "gold";
};

const CheckoutSummaryIcon: FunctionComponent<CheckoutSummarIconProps> = ({
  modifier,
}) => (
  <span
    className={classNames("checkout-summary__item__amount__description__icon", {
      "checkout-summary__item__amount__description__icon--gold":
        modifier === "gold",
      "checkout-summary__item__amount__description__icon--silver":
        modifier === "silver",
    })}
  />
);

const CheckoutSummary = () => {
  const { cart, hasGoldVariations, hasSilverVariations } = useCart();

  return (
    <section className="checkout-summary">
      {hasGoldVariations ? (
        <CheckoutSummaryItem header="Oro">
          <CheckoutSummaryIcon modifier="gold" />
          {displayWeight(String(cart?.summary.by_material.gold.weight))}
        </CheckoutSummaryItem>
      ) : null}
      {hasSilverVariations ? (
        <CheckoutSummaryItem header="Plata">
          <CheckoutSummaryIcon modifier="silver" />
          {displayWeight(String(cart?.summary.by_material.silver.weight))}
        </CheckoutSummaryItem>
      ) : null}
      <CheckoutSummaryItem header="Hechura">
        {displayMoney(Number(cart?.summary.totals.manufacturingCost))}
      </CheckoutSummaryItem>
    </section>
  );
};

export default CheckoutSummary;
